module.exports = __webpack_public_path__ + "static/media/rober10.7b47d921.jpg";